import { createFileRoute } from '@tanstack/react-router';
import { InfoPage } from '../components/InfoPage.js';

export const Route = createFileRoute('/warranty')({
  component: () => <InfoPage title="Warranty" />,
});
